<template>
  <div v-if="canEdit" class="header">
    <div class="header__input-container">
      <UiInput
        :value="search"
        placeholder="Поиск участника"
        icon="ui-search"
        icon-class="user-team-icon-search"
        @input="setFilter('search', $event)"
      />
      <UiSelectFilter
        v-if="cityList.length"
        :value="city"
        :option="cityList"
        placeholder="Город"
        :can-unset="true"
        :smart="true"
        :max-height="200"
        @input="setFilter('city', $event)"
      />
      <UiSelectFilter
        v-if="mode === 'allocated'"
        :value="captain"
        :option="captainList"
        placeholder="Капитан"
        :can-unset="true"
        :smart="true"
        :max-height="200"
        @input="setFilter('captain', $event)"
      />
      <UiSelectFilter
        v-if="mode === 'allocated'"
        :value="seniorCaptain"
        :option="seniorCaptainList"
        placeholder="Старший капитан"
        :can-unset="true"
        :smart="true"
        :max-height="200"
        @input="setFilter('seniorCaptain', $event)"
      />
      <UiSelectFilter
        v-if="course"
        :value="faculty"
        :option="facultyList"
        placeholder="Факультет / Сборная"
        :can-unset="true"
        :smart="true"
        :max-height="200"
        @input="setFilter('faculty', $event)"
      />
      <UiSelectFilter
        :value="course"
        :option="courseList"
        placeholder="Курс"
        :can-unset="true"
        :smart="true"
        :max-height="200"
        @input="setFilter('courseStreamId', $event)"
      />
    </div>
    <Button
      v-if="mode === 'allocated'"
      class="header__add-item-button"
      size="s"
      :disabled="user.isCaptain"
      @click="openAside"
    >
      Добавить команду
    </Button>
  </div>
</template>

<script>
import UiInput from '@/components/UiKit/Input';
import Button from '@/components/UiKit/v2/Button';
import UiSelectFilter from '@/components/UiKit/SelectFilter';
import { mapState } from 'vuex';

export default {
  components: {
    UiInput,
    Button,
    UiSelectFilter
  },
  props: {
    mode: {
      type: String,
      required: true,
      validator: value => ['allocated', 'unallocated'].includes(value)
    }
  },
  computed: {
    ...mapState('teamGroup', {
      captain: state => state.data.filterList.captain,
      seniorCaptain: state => state.data.filterList.seniorCaptain,
      city: state => state.data.filterList.city,
      search: state => state.data.filterList.search,
      faculty: state => state.data.filterList.faculty,
      course: state => state.data.filterList.courseStreamId,
      canEdit: state => state.data.settings.canEdit,
      settings: state => state.data.settings,
      captainList: state =>
        state.data.settings.captains.map(item => ({
          value: item.id,
          title: `${item.name} ${item.lastname}`
        })),
      seniorCaptainList: state =>
        state.data.settings.seniorCaptains.map(item => ({
          value: item.id,
          title: `${item.name} ${item.lastname}`
        })),
      facultyList: state =>
        state.data.settings.faculties.map(item => ({
          value: item.name,
          title: item.name
        })),
      cityList: state =>
        state.data.settings.cities.map(item => ({
          value: item,
          title: item
        })),
      courseList: state =>
        state.data.settings.streams.map(item => ({
          value: item.id,
          title: item.name
        }))
    }),
    ...mapState('auth', {
      user: s => s.data.user
    })
  },
  methods: {
    openAside() {
      this.$store.dispatch('asides/addAside', {
        data: {
          name: 'add-team-group',
          title: 'Добавление команды',
          subtitle: 'Укажите данные новой команды',
          slotClass: '-field-'
        }
      });
    },
    setFilter(path, value) {
      this.$store.dispatch('teamGroup/setFilter', { path, value });
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.header {
  $screen-sm: 600px;

  &__input-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 8px 12px;
    margin-bottom: 16px;
  }

  &__add-item-button {
    margin: 12px 0;

    @include media($screen-sm) {
      width: 100%;
    }
  }

  .ui-kit-input,
  .ui-kit-filter-select {
    min-width: unset;
  }
}
</style>
